import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseUkolySearch } from '@/modules/ukoly/filters';

const UkolDetail = lazy(() =>
  import('@/modules/ukoly/UkolDetail').then((m) => ({ default: m.UkolDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ukoly/$id',
  component: () => (
    <Suspense fallback={null}>
      <UkolDetail />
    </Suspense>
  ),
  // Same shape as the list route so the detail's master rail shows the same
  // cohort (state filter + mine + name search) the user was browsing.
  validateSearch: parseUkolySearch,
});
